import { themeObject } from 'lib';

export const expandableItemStyles = {
    hiddenMessage: {
        display: 'inline-flex',
        alignItems: 'baseline',
        height: '22px',
        overflow: 'hidden',
    },
    expandedMessage: {
        display: 'inline-flex',
        alignItems: 'baseline',
    },
    truncatedHiddenMessage: {
        display: 'inline-flex',
        alignItems: 'baseline',
        height: '22px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        textWrap: 'nowrap',
    },
    truncatedExpandedMessage: {
        display: 'inline-flex',
        alignItems: 'baseline',
    },
    container: {
        display: 'flex',
        alignItems: 'flex-start',
        width: '100%',
    },
    icon: {
        color: themeObject.palette.primary[500],
        width: 24,
        height: 24,
        paddingBottom: '3px',
    },
};
